module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.flag) ? _c('Button', {
    staticClass: "margin",
    on: {
      "click": _vm.toggle
    }
  }, [_vm._v("Отменить")]) : _c('div', {
    staticClass: "cancellation"
  }, [_c('Button', {
    attrs: {
      "border": true
    },
    on: {
      "click": function($event) {
        return _vm.$emit('cancel')
      }
    }
  }, [_vm._v("Да")]), _c('Button', {
    attrs: {
      "border": true
    },
    on: {
      "click": _vm.toggle
    }
  }, [_vm._v("Нет")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fd26fc80","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/blocks/cards/purchases/components/cancellation/Cancellation.vue
// module id = 3305adb0ab62fdbde8e9
// module chunks = 89